module.exports = __webpack_public_path__ + "static/headphones-recent-posts-section-eeb19051f47db8b33d5075181128f121.png";